export default __webpack_public_path__ + "static/media/mm.f6c8607e.svg";